import React,{useState} from 'react';
import './SearchCategoryComp.css'


const SearchCategoryComp =({type,setType})=>{

    var [catType,setCatType] = useState('Yachts');

    return(
        <div className='SearchCategoryCompMain0' onClick={()=>setType('')}>
            <button className={catType=='Yachts' ? 'selected0 first0' : 'notSelected0 first0'}
            onClick={()=>setCatType('Yachts')}>
                Yachts
            </button>
            <button className={catType=='Cars' ? 'selected0' : 'notSelected0'}
            onClick={()=>setCatType('Cars')}>
                Cars
            </button>
            <button className={catType=='Helicopters' ? 'selected0' : 'notSelected0'}
            onClick={()=>setCatType('Helicopters')}>
            Helicopters
            </button>
            <button className={catType=='Homes' ? 'selected0' : 'notSelected0'}
            onClick={()=>setCatType('Homes')}>
            Homes/Villas
            </button>
            <button className={catType=='Airplanes' ? 'selected0' : 'notSelected0'}
            onClick={()=>setCatType('Airplanes')}>
            Airplanes
            </button>

        </div>
    )


}

export default SearchCategoryComp;